export default {
  b2cTip:
    "I want to provide a better identity authentication experience for my C-terminal users.",
  b2bTip:
    "I want to provide a better authentication experience for my B-terminal customers.",
  b2eTip: "I want to manage the company's employee",
  tenants:
    "The number of tenants is only associated with different versions, not with MAU, which needs to be subscribed separately",
  unit: "$",
  banner: {
    title: "You only pay for",
    "title-other": "",
    MAU: "MAU",
    subtitle:
      "Authing has helped thousands of companies and developers to build standardized user identity systems",
    "common-tip":
      "Any user authenticated in a single user pool during a month.",
    "section-one": {
      title: "Free plan",
      button: "Start Building with Authing",
      descript: "Experience of 3 use cases, Up to 8,000 MAU",
    },
    "section-two": {
      title: "Complex case？",
      button: "Check It Out",
      descript:
        "Private deployment solutions to build your own IDaaS service for your enterprise",
    },
  },
  other: {
    free: "Free",
    sales: "Consultation",
  },
  priceList: {
    choose: "Choose your ",
    mau: "MAU",
    "choose-mau": "Choose your MAU: ",
    "choose-mauE": "Choose your number of employees: ",
    "choose-tip":
      "One year is free of charge for two months. Unlike other vendors, authing charges only MAU",
    MAU: "MAU",
    "choose-tip2": "",
    "choose-tip3":
      "Any user authenticated in a single user pool during a month.",
    "month-unit": "month",
    "app-scene": "What is your use case?",
    months: "months",
    "year-unit": "year",
    "monthly-payment": "Monthly",
    "annual-payment": "Annual",
    sale: "17% off",
    b2c: {
      develop: {
        title: "Essentials",
        function: {
          item1: "Unlimited Social Connections",
          item2: "10 Self-built Apps",
          item3: "5 Auto Workflows",
        },
      },
      developPro: {
        title: "Professional",
        function: {
          item1: "Unlimited Social Connections",
          item2: "20 Self-built Apps",
          item3: "Custimized Branding",
          item4: "Custimized Database",
          item5: "Muliti-Factor Authentication",
        },
      },
      enterprise: {
        title: "Enterprise",
        function: {
          item1: "Connections Based on Needs",
          item2: "Unlimited Usage ",
          item3: "Top Service-level Agreement",
          item4: "First-hour Aid",
          item5: "Customized Enterprise Support",
          item6: "Private Deployment（Add-on） ",
        },
      },
    },
    b2b: {
      develop: {
        title: "Essentials",
        function: {
          item1: "50 Tenants",
          item2: "Unlimited Social Connections",
          item3: "1 Enterprise Connection",
          item4: "10 Self-built Apps",
        },
      },
      developPro: {
        title: "Professional",
        function: {
          item1: "100 Tenants",
          item2: "Unlimited Social Connections",
          item3: "3 Enterprise Connections",
          item4: "20 Self-built & Intagreted Apps",
          item5: "Sync-up & ID Providing",
        },
      },
      enterprise: {
        title: "Enterprise",
        function: {
          item1: "Connections Based on Needs",
          item2: "Unlimited Usage ",
          item3: "Top Service-Level Agreement",
          item4: "First-hour Aid",
          item5: "Customized Enterprise Support",
          item6: "Private Deployment（Add-on）",
        },
      },
    },
    b2e: {
      develop: {
        title: "Professional",
        function: {
          item1: "3 Enterprise Connection",
          item2: "20Self-built & Intagreted Apps ",
          item3: "Cross APP SSO",
          item4: "Sync-up & ID Providing",
          item5: "Organization Structure & LDAP",
        },
      },
      enterprise: {
        title: "Enterprise",
        function: {
          item1: "Connections Based on Needs",
          item2: "Unlimited Usage ",
          item3: "Top Service-level Agreement",
          item4: "First-hour Aid",
          item5: "Customized Enterprise Support",
          item6: "Private Deployment（Add-on）",
        },
      },
    },
  },
  compare: {
    title: "Function Comparison",
    free: "Free",
    develop: "Essentials",
    "develop-pro": "Professional",
    enterprise: "Enterprise",
    authentication: {
      title: "Authentication",
      feature1: {
        title: "Customer Identity",
        enterprise: "As many as you need",
        des:
          "Any user that authenticated during a given mouth for a given user pool.",
        b2c: {
          free: "Free 8K MAU",
          develop: "Up to 10K MAU",
          developPro: "Up to 10K MAU",
        },
        b2b: {
          free: "Free 200 MAU",
          develop: "Up to 1K MAU",
          developPro: "Up to 1K MAU",
        },
        b2e: {},
      },
      feature2: {
        title: "Employee Identity",
        enterprise: "As many as you need",
        des:
          "An internal employee of your company that authenticated with any connection or identity provider.",
        b2c: {},
        b2b: {},
        b2e: {
          free: "Up to 10 MAU",
          develop: "Up to 100 MAU",
        },
      },
      feature3: {
        title: "Social Connections",
        enterprise: "Unlimited",
        des:
          "Authing supports every popular social site,e.g.such as WeChat,Weibo,and GitHub,and can work with any ldP compatible with OAuth2.",
        b2c: {
          free: "",
          develop: "Unlimited",
          developPro: "Unlimited",
        },
        b2b: {
          free: "",
          develop: "Unlimited",
          developPro: "Unlimited",
        },
        b2e: {
          free: "",
          develop: "Unlimited",
        },
      },
      feature4: {
        title: "Enterprise Connections",
        enterprise: "Unlimited",
        des:
          "Enterprise ldPs supporting protocols like SAML,Enterprise OIDC,AD/LDAP,OAuth 2.0,Ding Talk,and WeCom(among others) to authenticate and synchronize your users.",
        b2c: {},
        b2b: {},
        b2e: {},
      },
      feature5: {
        title: "External Database",
        enterprise: "",
        des:
          "Connect to an existing store or database through a Javascript script that runs on Authing's server on every authentication.",
        b2c: {},
        b2b: {},
        b2e: {},
      },
      feature6: {
        title: "Branded Identity",
        des:
          "Authing supports self-built applications with the same identity source capabilities as WeChat and Alipay, allowing other applications to access, thereby improving the brand awareness of self-built applications. Typical scenario: Login with a self-built application.",
        enterprise: "",
        b2c: {},
        b2b: {},
        b2e: {},
      },
      feature7: {
        title: "Cross APP SSO",
        des:
          "Give your customers,partners and employees the freedom of Single Sign On while keeping the control and enhanced security you need.",
        enterprise: "",
        b2c: {},
        b2b: {},
        b2e: {},
      },
      feature8: {
        title: "Authing Launchpad",
        des:
          "Authing launchpad is the front door to all the applications. Once the user is in, he will see a custom dashboard tailored to have all the applications IT has assigned to him. Single click on one and the user is automatically logged in. No need to re-enter any credentials.",
        enterprise: "",
        b2c: {},
        b2b: {},
        b2e: {},
      },
      feature9: {
        title: "Self-built App",
        enterprise: "Unlimited",
        des: "Integrate mobile, web, and IoT applications with Authing.",
        b2c: {},
        b2b: {},
        b2e: {},
      },
      feature10: {
        title: "SSO Integrations",
        enterprise: "Unlimited",
        des:
          "Quick and wasy single-sign-on for your existing applications and SaaS services such as Office 365,Salesforce,and others.",
        b2c: {},
        b2b: {},
        b2e: {},
      },
      feature11: {
        title: "Identity Provision",
        des:
          "users who operate the app in the Authing management background add, delete, modify, and check. Authing will synchronize the user's modifications to this app in real time.",
        enterprise: "",
        b2c: {},
        b2b: {},
        b2e: {},
      },
    },
    brand: {
      title: "Branding",
      feature1: {
        title: "Custom Login",
        des:
          "Customize the login experience utilizing both our no code and pro code tools.",
        enterprise: "",
        b2c: {},
        b2b: {},
        b2e: {},
      },
      feature2: {
        title: "Custom Emails",
        enterprise: "",
        des:
          "Standard welcome,password reset ,and account verification email-based workflows,built right into Authing and easy to access and use.",
        b2c: {},
        b2b: {},
        b2e: {},
      },
      feature3: {
        title: "Custom User Agreement",
        enterprise: "",
        des:
          "It is used for users to understand your terms of service and privacy clauses when registering/logging in. Users need to check the corresponding content when registering/logging in.",
        b2c: {},
        b2b: {},
        b2e: {},
      },
    },
    automation: {
      title: "Automatic",
      feature1: {
        title: "Authing Pipeline",
        enterprise: "Unlimited",
        des:
          "Custom Javascript snippets that run in a secure,isolated sandbox in the Authing service as part of your authentication pipeline - limited only by your imagination.",
        b2c: {},
        b2b: {},
        b2e: {},
      },
      feature2: {
        title: "Webhooks",
        enterprise: "Unlimited",
        des:
          "Push notifications for user and administrator platform usage trigger events.",
        b2c: {},
        b2b: {},
        b2e: {},
      },
    },
    security: {
      title: "Security",
      feature1: {
        title: "Brute-force Protection",
        des:
          "Enabled by default for all connections,protecets a user against a targeted hacking attempt.",
        enterprise: "",
        b2c: {},
        b2b: {},
        b2e: {},
      },
      feature2: {
        title: "Password Security",
        des:
          "A way to increase the security of passwords by making them more difficult to guess through brute force attacks. Authing supports standards to specify the password format and rotation rules for password security. ",
        enterprise: "",
        b2c: {},
        b2b: {},
        b2e: {},
      },
      feature3: {
        title: "SMS One-time Passwords",
        enterprise: "Free SMS 12,000/mo",
        des:
          "An alternative to using username / password credentials to authenticate a user.",
        b2c: {
          free: "Free SMS 100/mo",
          develop: "Free SMS 300/mo",
          developPro: "Free SMS 1,500/mo",
        },
        b2b: {
          free: "Free SMS 100/mo",
          develop: "Free SMS 300/mo",
          developPro: "Free SMS 1,500/mo",
        },
        b2e: {
          free: "Free SMS 100/mo",
          develop: "Free SMS 300/mo",
        },
      },
      feature4: {
        title: "Custom SMS Gateway",
        des:
          "By default, Passwordless SMS connections use Authing SMS Gateway to send out one-time passwords. However, if you have a custom SMS gateway, you can modify your connection to use that instead. ",
        enterprise: "",
        b2c: {},
        b2b: {},
        b2e: {},
      },
      feature5: {
        title: "Pro Multi-factor Auth",
        enterprise: "Unlimited",
        des:
          "Use one-time codes delivered via SMS, voice or email, onetime password apps like Microsoft Authenticator and Authing face recognition to prompt users for an additional factor when logging in. ",
        b2c: {},
        b2b: {},
        b2e: {},
      },
      feature6: {
        title: "Delegated Admin",
        enterprise: "Unlimited",
        des:
          "Invite other developers and teams to edit and configure Authing for needs across your business. ",
        b2c: {},
        b2b: {},
        b2e: {},
      },
    },
    "user-directory": {
      title: "User Contents",
      feature1: {
        title: "User Management",
        des:
          "User interface tools to help administrators manage user identities including password resets, creating and provisioning, blocking and deleting users. Authing includes a powerful user management dashboard built on top of the platform's advanced APIs. ",
        enterprise: "",
        b2c: {},
        b2b: {},
        b2e: {},
      },
      feature2: {
        title: "Custom User Attributes",
        enterprise: "Unlimited",
        des:
          "Add custom attributes to user metadata to meet your unique use cases.",
        b2c: {},
        b2b: {},
        b2e: {},
      },
      feature3: {
        title: "Authorization",
        enterprise: "",
        des:
          "Effective user management with the ability to create groups and permissions and deliver granular access control. ",
        b2c: {},
        b2b: {},
        b2e: {},
      },
      feature4: {
        title: "Groups",
        enterprise: "",
        des:
          "Users can be managed in groups and authorized in a unified manner.",
        b2c: {},
        b2b: {},
        b2e: {},
      },
      feature5: {
        title: "Organizations",
        enterprise: "",
        des:
          "Refined management of organizations and employees, including: organizations importing, addition, deletion, modification, and review of organizations, addition and deletion of mobile nodes, etc.",
        b2c: {},
        b2b: {},
        b2e: {},
      },
      feature6: {
        title: "Sync Center",
        enterprise: "",
        des:
          "Automatic synchronization of organization and user information for upstream data sources and downstream business systems.",
        b2c: {},
        b2b: {},
        b2e: {},
      },
      feature7: {
        title: "Tenants Beta",
        enterprise: "As many as you need",
        des:
          "Tenants represent customers who use your SaaS application. We will provide tenant-level identity authentication and authorization, end user management, login page branding and other functions for your application.",
        b2c: {},
        b2b: {},
        b2e: {},
      },
      feature8: {
        title: "LDAP",
        enterprise: "",
        des:
          "LDAP stands for the Lightweight Directory Access Protocol. You can interpret it as a tree-shaped database used to store users' and organizations' information. It is often used for uniform identity authentication.",
        b2c: {},
        b2b: {},
        b2e: {},
      },
      feature9: {
        title: "Custom Role Attributes",
        enterprise: "Unlimited",
        des:
          "Add custom attributes to role metadata to meet your unique use cases.",
        b2c: {},
        b2b: {},
        b2e: {},
      },
      feature10: {
        title: "Custom Dept. Attributes",
        enterprise: "Unlimited",
        des:
          "Add custom attributes to department metadata to meet your unique use cases.",
        b2c: {},
        b2b: {},
        b2e: {},
      },
      feature11: {
        title: "Registration Whitelist",
        enterprise: "Unlimited",
        des:
          "After opening, only the mobile phone number, email address and user name in the whitelist can be registered.",
        b2c: {},
        b2b: {},
        b2e: {},
      },
    },
    "service-support": {
      title: "Platform Support",
      feature1: {
        title: "Log Retention",
        enterprise: "Up to 30 Days",
        des:
          "Longer storage of log data to meet compliance requirements or to facilitate diagnosis and resolution of authentication issues, and forensic analysis. ",
        b2c: {
          free: "Up to 1 Day",
          develop: "Up to 3 Days",
          developPro: "Up to 10 Days",
        },
        b2b: {
          free: "Up to 1 Day",
          develop: "Up to 3 Days",
          developPro: "Up to 10 Days",
        },
        b2e: {
          free: "Up to 1 Day",
          develop: "Up to 10 Days",
        },
      },
      feature2: {
        title: "SLA",
        enterprise: "",
        des:
          "Service Level Agreement. A commitment by Authing to deliver an agreed level of end-user availability of service .",
        b2c: {},
        b2b: {},
        b2e: {},
      },
      feature3: {
        title: "Support Availability",
        des:
          "Customer has access to a WeChat Group support reserved solely for paid customers, with priority conference call with our Support Engineer. Online cases are responded to within the response timeframes below. ",
        enterprise: "",
        b2c: {},
        b2b: {},
        b2e: {},
      },
      feature4: {
        title: "Response Time",
        des:
          "Authing will use reasonable efforts to adhere to the response times pursuant to the customers’ paid plans .",
        enterprise: "Response in 1 Hour",
        b2c: {
          free: "",
          develop: "Response in 48 Hours",
          developPro: "Response in 24 Hours",
        },
        b2b: {
          free: "",
          develop: "Response in 48 Hours",
          developPro: "Response in 24 Hours",
        },
        b2e: {
          free: "",
          develop: "Response in 24 Hours",
        },
      },
      feature5: {
        title: "Community Support",
        des: "Ask questions and get answers via the Authing community forum. ",
        enterprise: "",
        b2c: {},
        b2b: {},
        b2e: {},
      },
      feature6: {
        title: "Enterprise Support",
        des:
          "Enterprise-grade support agreement that includes a designated Customer Success Manager and a designated team of Developer Support Engineers. ",
        enterprise: "",
        b2c: {},
        b2b: {},
        b2e: {},
      },
      feature7: {
        title: "Private Deployment",
        enterprise: "Support purchase",
        des:
          "Authing is responsible for all delivery and system launch, including private deployment, demand research in the management process, system deployment, implementation and development, test and continuous commissioning, production launch and project management.",
        b2c: {},
        b2b: {},
        b2e: {},
      },
    },
    // authentication: {
    //   title: "Authentication",
    //   feature1: {
    //     title: "Customer Identity",
    //   },
    //   feature2: {
    //     title: "Employee Identity",
    //   },
    //   feature3: {
    //     title: "Social Connections",
    //   },
    //   feature4: {
    //     title: "Enterprise Connections",
    //   },
    //   feature5: {
    //     title: "External Database",
    //   },
    //   feature6: {
    //     title: "Federal Authentication",
    //   },
    //   feature7: {
    //     title: "Cross APP SSO",
    //   },
    //   feature8: {
    //     title: "Authing Launchpad",
    //   },
    //   feature9: {
    //     title: "Self-built App",
    //   },
    //   feature10: {
    //     title: "SSO Integrations",
    //   },
    //   feature11: {
    //     title: "Identity Provision",
    //   },
    // },
    // brand: {
    //   title: "Branding",
    //   feature1: {
    //     title: "Custom Login",
    //   },
    //   feature2: {
    //     title: "Custom Emails",
    //   },
    //   feature3: {
    //     title: "Custom User Agreement",
    //   },
    // },
    // automation: {
    //   title: "Automatic",
    //   feature1: {
    //     title: "Authing Pipeline",
    //   },
    //   feature2: {
    //     title: "Webhooks",
    //   },
    // },
    // security: {
    //   title: "Security",
    //   feature1: {
    //     title: "Brute Force Protection",
    //   },
    //   feature2: {
    //     title: "Password Security",
    //   },
    //   feature3: {
    //     title: "SMS One-time Passwords",
    //   },
    //   feature4: {
    //     title: "Custom SMS Gateway",
    //   },
    //   feature5: {
    //     title: "Pro Multi-factor Auth",
    //   },
    //   feature6: {
    //     title: "Delegated Admin",
    //   },
    // },
    // "user-directory": {
    //   title: "User Contents",
    //   feature1: {
    //     title: "User Management",
    //   },
    //   feature2: {
    //     title: "Custom Attributes",
    //   },
    //   feature3: {
    //     title: "Authorization",
    //   },
    //   feature4: {
    //     title: "Groups",
    //   },
    //   feature5: {
    //     title: "Organizations",
    //   },
    //   feature6: {
    //     title: "Sync Center",
    //   },
    //   feature7: {
    //     title: "Tenants Beta",
    //   },
    //   feature8: {
    //     title: "LDAP",
    //   },
    // },
    // "service-support": {
    //   title: "Platform Support",
    //   feature1: {
    //     title: "Log Retention",
    //   },
    //   feature2: {
    //     title: "SLA",
    //   },
    //   feature3: {
    //     title: "Support Availability",
    //   },
    //   feature4: {
    //     title: "Response Time",
    //   },
    //   feature5: {
    //     title: "Community Support",
    //   },
    //   feature6: {
    //     title: "Enterprise Support",
    //   },
    // },
  },
  question: {
    title: "Common Problem",
    "item-one": {
      title: "How do I choose Authing technology?",
      descript:
        "How do I choose Authing technology? Please choose the technology you want to use according to your specific situation. Before you start, we recommend that you read this article:",
      link: "Why should all software use single sign-on to manage users?",
    },
    "item-two": {
      title: "How to choose the authentication method?",
      descript:
        "If you do not understand the standard protocols such as OAuth, OIDC, SAML, LDAP and so on, and the application security requirements are not high, it is recommended to use common authentication; if your application security requirements are high, whether you understand the standard protocol or not, please use the standard protocol authentication.",
    },
    "item-three": {
      title: "What is Authing？",
      descript:
        "Authing provides professional authentication and authorization services. We provide developers and businesses with authentication modules needed to secure their applications, which eliminates the need for developers to become security experts. You can connect the application of any platform to Authing (whether it is a newly developed application or an old application), and you can also customize the login method of the application (such as email/password, SMS / verification code, scanning code, etc.). You can choose our SDK or call relevant API to access your application according to the technology you use. When a user initiates an authorization request, Authing will help you authenticate their identity and return the necessary user information to your application.",
    },
    "item-four": {
      title: "Why use Authing？",
      other: "Here are some usage scenarios of Authing:",
      "descript-one":
        "You want to develop a cool program, and you want to add user authentication and authorization. You want your users to use WeChat and GitHub to log in. At the same time, you also want to track the user's registration source and activity data, so that you can make subsequent user growth.",
      "descript-two":
        "You have made an API, and you hope to use the OAuth 2.0 protocol to ensure the security of the API.",
      "descript-three":
        "You have made a lot of applications, and you hope that the user data of these applications can be communicated through single sign-on.",
      "descript-four":
        "You have made a JavaScript front-end application and a mobile application, and you hope that both client applications can access your API safely.",
      link: "Read the document",
    },
  },
};
